export const CHAT_LOADER_SRC = "https://cdn.chatsimple.ai/chat-bot-loader.js";

export const CHAT_BOT_ATTRIBUTES = Object.freeze({
  platform_id: "a4889c71-36b5-4f66-9c0d-d8d92ae40140",
  user_id: "35f06cce-dde9-474b-be4b-87da2809f62f",
  chatbot_id: "73951f4c-ec8a-4ffe-9448-2ad1fb434a2b",
});

export const CHAT_LOAD_TIMEOUT_MS = 15_000;
